import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";
import { SiteFooter } from "@/components/Legal";
import { api, errMsg } from "@/lib/api";

export default function Home() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const join = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.get(`/play/check/${code}`);
      navigate(`/katil/${code}`);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="h-[100dvh] overflow-hidden flex flex-col items-center justify-center px-5 py-6">
      <main className="w-full max-w-md space-y-6 sm:space-y-7 fade-in" data-testid="home-page">
        <Logo size="lg" />
        <div className="space-y-2">
          <h1 className="font-display text-4xl sm:text-5xl font-bold leading-[1.05]" data-testid="home-title">
            Hoş geldin,<br /><span className="neon-text-green">Laboratuvara Giriş Yap!</span>
          </h1>
          <p className="text-slate-300 text-base sm:text-lg">Tahtadaki kodu yaz ya da QR kodu okut.</p>
        </div>
        <form onSubmit={join} className="panel p-5 sm:p-7 space-y-4">
          <label htmlFor="game-code" className="eyebrow block">Oyun kodu</label>
          <input id="game-code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            inputMode="numeric" autoComplete="off" placeholder="000000" data-testid="game-code-input"
            className="w-full h-16 sm:h-20 rounded-2xl bg-[#0B0F16] border-2 border-[#FACC15] text-center font-display text-4xl font-bold tracking-[0.45em] pl-[0.45em] text-white placeholder:text-slate-600 outline-none focus:shadow-[0_0_0_4px_rgba(250,204,21,0.2)] transition-shadow duration-200" />
          <Button type="submit" disabled={code.length !== 6 || busy} className="w-full h-14 sm:h-16 text-xl" data-testid="join-game-button">
            Devam <ArrowRight className="!h-5 !w-5 ml-1" />
          </Button>
        </form>
        <p className="text-center">
          <Link to="/ogretmen/giris" data-testid="teacher-login-link" className="text-sm text-slate-400 hover:text-[#FACC15] transition-colors duration-150">Öğretmen girişi</Link>
        </p>
        <div data-testid="home-signature"><SiteFooter inPanel signature /></div>
      </main>
    </div>
  );
}
